import React from 'react';

// Styles
import classNames from 'classnames';

import styles from './SectionContentComponent.module.scss';

class SectionContentComponent extends React.Component {
  constructor() {
    super();

    this.element = React.createRef();
  }

  render() {
    const { className, isWide } = this.props;
    return (
      <div
        className={classNames(
          styles.content,
          { [styles.contentWide]: isWide },
          className
        )}
        ref={this.element}
      >
        {this.props.children}
      </div>
    );
  }

  getElement() {
    return this.element.current;
  }
}

export default SectionContentComponent;
